import PropTypes from "prop-types";
import React from "react";
import { MSpinner, TextBlock } from "components/Shared";
import Card from "react-md/lib/Cards/Card";
import CardTitle from "react-md/lib/Cards/CardTitle";
import CardText from "react-md/lib/Cards/CardText";

const Notifications = ({ isFetching, items }) => {
  if (isFetching) {
    return <MSpinner/>;
  }

  let title = (items.length === 0)
    ? "There are no new notifications."
    : "There are " + items.length + " notification(s)";
  return (
    <Card className="md-cell md-cell--4 md-cell--right">
      <CardTitle title="Notifications" />
      <CardText>
        <TextBlock field={title} placeholder="" styleClass="fieldText-bold" />
        <br />
      </CardText>
    </Card>
  );
};

Notifications.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired
};

export default Notifications;